import { Checkbox, Dialog, Typography } from "@mui/material";
import React, { useState } from "react";
import { Close, ErrorOutline } from "@mui/icons-material";
import CustomButton from "../../../reusableComponents/CustomButton";
import { useAuth } from "../../../context/API_Client";
import { customToast } from "../../../reusableComponents/customToaster/customToast";

function DeleteModal({ isOpen, setIsOpen, onClick, ruleId, setRuleData, setIsRuleAvailable, dataLength }) {

  const [loader, setLoader] = useState(false)
  const { deleteRoutingRule } = useAuth();
  const handleKeyDownFallback = (event) => {
    if (event.key === "Escape") {
      setIsOpen(false);
    }
  };

  const handleDeleteRule = async () => {
    try {
      setLoader(true);
      await deleteRoutingRule(
        ruleId,
        () => {
          if (dataLength == 1) {
            setIsRuleAvailable(false)
          }
          setRuleData((state) => state.filter((el) => el.ruleId !== ruleId));
          setIsOpen(false);
        },
        (errMsg) => {
          customToast("error", "high", errMsg || "Something Went Wrong");
        }
      );
      setLoader(false);
    } catch (err) {
      setLoader(false);
      customToast("error", "high", "Something Went Wrong");
    }
  };

  return (
    <Dialog
      open={isOpen}
      PaperProps={{
        style: {
          borderRadius: "12px",
          maxWidth: "500px",
        },
      }}
      onKeyDown={handleKeyDownFallback}
    >
      <div className="">
        <div
          className="d-flex align-items-start w-100 justify-content-between"
          style={{ padding: "24px 24px 0px 24px" }}
        >
          <div
            className="d-flex align-items-start  justify-content-start"
            style={{ gap: 10 }}
          >
            <ErrorOutline style={{ color: "#F53535" }} />
            <Typography
              sx={{
                color: "#1D1C20",
                fontWeight: 500,
              }}
            >
              Are you sure you want to delete this rule?
            </Typography>
          </div>
          {/* <Close
            style={{ cursor: "pointer" }}
            onClick={() => setIsOpen(false)}
          /> */}
        </div>
        <hr />

        <div className="px-4">
          <div className="mt-4 d-flex align-items-center mb-4" >
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: 400,
                color: "#2D2B32",
                letterSpacing: "-0.2px",
              }}
            >
              This action can’t be undone.
            </Typography>
          </div>
        </div>
      </div>

      <div className="modalBottomBar mt-3" style={{ boxShadow: "0 -15px 28px -15px rgba(39, 39, 39, 0.15)" }}>
        <CustomButton
          text={"Cancel"}
          onClick={() => setIsOpen(false)}
          variant={"outlined"}
          type={"error"}
          disabled={loader}
        />
        <CustomButton
          text={"Delete"}
          loading={loader}
          onClick={handleDeleteRule}
          variant={"contained"}
          type={"error"}
        />
      </div>
    </Dialog>
  );
}

export default DeleteModal;
